export default "__VITE_ASSET__DvTl9wP5__"